module.exports = __webpack_public_path__ + "img/42.1ddf3861.jpg";